import {customerDeviceIdentity} from './customer-review-display.js';
// Product names approved by the user on 2026-10-08. Wire/inventory model codes stay unchanged.
export const MODEL_PRODUCTS = [
 {id:'qtracker-go',name:'Qtracker Go',models:['T11','YG-T11']},
 {id:'qtracker-go-plus',name:'Qtracker Go Plus',models:['T12','YG-T12']},
 {id:'qtracker-max',name:'Qtracker Max',models:['D3','YG-D3']},
 {id:'qtracker-max-pro',name:'Qtracker Max Pro',models:['D3 Pro','YG-D3 Pro','YG-D3pro']},
 {id:'qtracker-drive',name:'Qtracker Drive',models:['T94','YG-T94']},
 {id:'qtracker-drive-pro',name:'Qtracker Drive Pro',models:['T94 Pro','YG-T94 Pro','YG-T94pro']},
 {id:'qtracker-drive-obd',name:'Qtracker Drive OBD',models:['OBD','YG-OBD']},
 {id:'qtracker-care-go',name:'Qtracker Care Go',models:['Faldalarmboks','V51','RF-V51']},
 {id:'qtracker-care-band',name:'Qtracker Care Band',models:['V48','V48C','RF-V48','RF-V48C']},
 {id:'qtracker-care-watch',name:'Qtracker Care Watch',models:['V52','RF-V52']},
 {id:'wonlex-ct30-pro',name:'Qtracker Care Watch Pro',models:['CT30 Pro','CT30PRO'],iconId:'qtracker-care-watch'},
 {id:'wonlex-ct10t',name:'CT10T',models:['CT10T'],iconId:'qtracker-care-watch'},
 {id:'qtracker-pet-go',name:'Qtracker Pet Go',models:['V41','RF-V41']},
 {id:'qtracker-pet-go-mini',name:'Qtracker Pet Go Mini',models:['V43','RF-V43']},
];
const key = value => typeof value==='string'?value.trim().toLocaleLowerCase('en-US').replace(/[\s_-]+/g,''):'';
const byModel = new Map(MODEL_PRODUCTS.flatMap(product=>[...product.models,product.name,product.id].map(model=>[key(model),product])));
export const modelProduct = profile => byModel.get(key(typeof profile==='string'?profile:profile?.model))??null;
export const modelName = profile => modelProduct(profile)?.name??(typeof profile==='string'?profile:profile?.model)??'';
export const isCareProduct = profile => {
 const product=modelProduct(profile);
 return product?.id.startsWith('qtracker-care-')||product?.id.startsWith('wonlex-')||key(profile?.model??profile)==='tryghedsalarm';
};
export function productDeviceName(device) {
 const name=device?.displayName?.trim(),profile=device?.profile??device;
 // Convert exact manufacturer aliases only. Personal names remain untouched.
 if(name)return modelProduct(name)?.name??name;
 return modelName(profile)||customerDeviceIdentity(device)||'Qtracker';
}
